import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { SkillService } from '../../../../../skill/services/skill.service';
import { SkillPersistenceService } from '../../../../../skill/services/skill-persistence.service';
import { cloneDeep } from 'lodash';
import { MenuItem, MessageService } from 'primeng/api';
import { Skill } from '../../../../../skill/models/skill';
import { LinkedTrainingItem } from '../../../../../skill/models/linked-item';
import { TrainingItemGroupSearchResult } from '../../../../../training-item-group-search/models/training-item-group-search-result';
import { TrainingItemGroupService } from '../../../../../training-item/services/training-item-group.service';
import { SkillConstants } from '../../../../../skill/constants/skill-constants';
import { TrainingItemGroupDetails } from '../../../../../training-item/models/training-item-group-detail';
import { TrainingItemGroupSearchComponent } from '../../../../../training-item-group-search/training-item-group-search/training-item-group-search.component';

@Component({
  selector: 'app-skill-training-item-group-details',
  templateUrl: './skill-training-item-group-details.component.html',
  styleUrls: ['./skill-training-item-group-details.component.scss']
})
export class SkillTrainingItemGroupDetailsComponent implements OnInit {
  feature:string = SkillConstants.Skill_Feature;
  constructor(private skillPersistenceService: SkillPersistenceService,
    private skillService: SkillService, private messageService: MessageService,
    private trainingItemGroupService: TrainingItemGroupService) {
    this.items = [
      {
        label: 'Add',
        command: this.add
      }
    ]
  }

  ngOnInit(): void {
    this.skillPersistenceService.closeAndResetSkillSlider$.subscribe((isClose) => {
      if (isClose) { this.closeAndResetSkillSlider(); }
    })
    this.skillPersistenceService.resetSelectionAfterAdd$.subscribe((reset) => {
      if (reset) { this.clearSelections(); }
    })
  }

  isSkillSaveInProgress: boolean = false;
  selectedTrainingItemGroups: TrainingItemGroupSearchResult[] = [];
  displayDataCollected: string[] = [];
  trainingItemGroupSearchResult: TrainingItemGroupSearchResult[] = [];
  trainingItemGroupDetails: TrainingItemGroupDetails[] = [];
  showAddButton: boolean = false;
  addAndClose: boolean = false;
  eQMSScopes: number[] = [];
  trainingItemNumbers: string[] = [];
  validTrainingItemGroups: string[] = [];
  items: MenuItem[] = [];
  errorCount: number = 0;
  scope?: number;
  skill !: Skill;
  isUpdate: boolean = false;
  @Input() selectedScope!: any;
  @Input() skillCode !: string;
  @ViewChild(TrainingItemGroupSearchComponent)
  private trainingGroupItemSearch!: TrainingItemGroupSearchComponent;

  add = () => {
    this.addAndClose = false;
    this.getLinkedItems(this.addAndClose);
  };

  closeAndResetSkillSlider() {
    this.selectedTrainingItemGroups = [];
    this.displayDataCollected = [];
    this.trainingItemGroupSearchResult = [];
    this.showAddButton = false;
  }

  clearSelections() {
    this.selectedTrainingItemGroups = [];
    this.displayDataCollected = [];
    if (this.trainingGroupItemSearch) {
      this.trainingGroupItemSearch.getLinkedItemsSelection();
    }
  }

  onSelectionOrDeselection = (trainingItemGroups: TrainingItemGroupSearchResult[]) => {
    let selectedTrainingItemGroupsList: string[] = [];
    trainingItemGroups.forEach(element => {
      selectedTrainingItemGroupsList.push(element.number);
    });
    this.displayDataCollected = []
    this.displayDataCollected = selectedTrainingItemGroupsList;
    this.selectedTrainingItemGroups = [];
    this.selectedTrainingItemGroups = cloneDeep(trainingItemGroups);
  }

  showOrHideAddButton = (displayAddBtn: boolean) => {
    this.showAddButton = displayAddBtn;
  }
  addSkillAndClose() {
    this.addAndClose = true;
    this.getLinkedItems(this.addAndClose);
  }

  getLinkedItems(addAndClose: boolean) {
    this.eQMSScopes = [];
    this.displayDataCollected = Object.assign([], this.displayDataCollected);
    this.errorCount = 0;
    //Get skill
    this.skillService.getSkillByCode(this.skillCode).subscribe((skill) => {
      this.skill = skill;
      this.skillPersistenceService.updateSkillDetails(skill);
      if (this.skill != null) {
        this.isUpdate = true;
      }
      //Get training items of the selected training item groups
      this.trainingItemGroupService.getTrainingItems(this.displayDataCollected).subscribe((trainingGroupItemsDetails: any[]) => {
        this.trainingItemGroupDetails = trainingGroupItemsDetails;
        this.validateAndCreateOrUpdateSkill(addAndClose);
        this.trainingGroupItemSearch.getLinkedItemsSelection();
      });
    });
  }

  validateAndCreateOrUpdateSkill(addAndClose: boolean) {
    if (this.displayDataCollected.length <= 0) {
      this.validateToSelectAtleastOneTrainingItem();
    }else {
      this.getParentScopesAndCompare(addAndClose);
    }
  }

  getParentScopesAndCompare(addAndClose: boolean) {
    const scopes: number[] = [];
    this.selectedScope.map((scope: any) => {
      scopes.push(scope);
    });
    const matchingtrainingItemGroups: any[] = [];
    const mismatchedtrainingItemGroups: any[] = [];

    this.displayDataCollected.forEach((data) => {
      var trainingItemGroupDetail = this.trainingItemGroupDetails.filter((tig) => { return tig.number === data });
      const { eQMSScopes } = trainingItemGroupDetail[0];
      const hasMatch = eQMSScopes.some((scope: number) => scopes.includes(scope));
      if (hasMatch) {
        matchingtrainingItemGroups.push(data);
      } else {
        mismatchedtrainingItemGroups.push(data);
      }
    });
    if (mismatchedtrainingItemGroups.length) {
      this.displayScopeValidationMessage(mismatchedtrainingItemGroups);
    }
    if (matchingtrainingItemGroups.length) {
      this.selectedItems(matchingtrainingItemGroups);
      this.updateSkill(matchingtrainingItemGroups, addAndClose); 
    }
  }

  updateSkill(matchingtrainingItemGroups: any[], addAndClose: boolean) {
    let matchingTrainingItemGroupsDetails = this.trainingItemsOfValidTrainingItemGroups(matchingtrainingItemGroups);
    this.skillPersistenceService.prepareDataForTrainingItemGroupTrainingItem(matchingTrainingItemGroupsDetails,
      this.isUpdate, this.skill);
    if (this.skillPersistenceService.duplicateTrainingItemsNumber.length > 0) {
      const trainingItemCode = this.skillPersistenceService.duplicateTrainingItemsNumber.map((item) => `${item}`).join(',');
      const validationMessage = SkillConstants.Skill_Warning_TrainingItemAlreadyPresentMessage.replace(
        'TrainingItems',
        `\n${trainingItemCode}`
      );
      this.messageService.add({
        severity: SkillConstants.Severity_Warning,
        summary: `${validationMessage}`,
        sticky: true
      });
    }
    if (this.skillPersistenceService.duplicateTrainingItemNumbersWithRemoveStatus.length > 0) {
      const trainingItemCode = this.skillPersistenceService.duplicateTrainingItemNumbersWithRemoveStatus.map((item) => `${item}`).join(',');
      const validationMessage = SkillConstants.Skill_Warning_TrainingItemMovedToActiveMessage.replace(
        'TrainingItems',
        `\n${trainingItemCode}`
      );
      this.messageService.add({
        severity: SkillConstants.Severity_Warning,
        summary: `${validationMessage}`,
        sticky: true
      });
    }
    this.skillPersistenceService.updateSkill(addAndClose);
  }

  selectedItems(serviceData: any[]) {
    if (!this.validTrainingItemGroups || this.validTrainingItemGroups.length === 0) {
      this.validTrainingItemGroups = serviceData;
    } else {
      this.validTrainingItemGroups.push(...serviceData);
    }
  }

  displayScopeValidationMessage(mismatchedtrainingItemGroups: any[]) {
    this.errorCount = 0;
    const trainingItemGroupNumbersString = mismatchedtrainingItemGroups.map((trainingItemGroup) => `  ${trainingItemGroup}`).join(', ');
    const validationMessage = SkillConstants.Selected_TrainingItemGroupscopes_Not_Matching_Error_Message.replace(
      'TrainingItemGroupNumbers',
      `\n${trainingItemGroupNumbersString}`
    );
    this.messageService.add({
      severity: SkillConstants.Severity_Err,
      summary: `${validationMessage}`,
      sticky: true
    });
    this.errorCount++;
  }

  validateToSelectAtleastOneTrainingItem() {
    this.errorCount = 0;
    this.messageService.add({
      severity: SkillConstants.Severity_Err,
      summary: `${SkillConstants.AtleastOneTrainingItem_ShouldBeSelected}`,
      sticky: true
    });
    this.errorCount++;
  }

  trainingItemsOfValidTrainingItemGroups(trainingItemGroupNumbers: string[]): TrainingItemGroupDetails[] {
    let trainingItemGroups: TrainingItemGroupDetails[] = [];
    trainingItemGroupNumbers.forEach((tig) => {
      trainingItemGroups.push(this.trainingItemGroupDetails.filter((tigDeatils) => {
        return tigDeatils.number === tig;
      })[0]
      );
    });
    return trainingItemGroups;
  }
}

